import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './common/style/reset.scss'
import '@/icons'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import VueBus from 'vue-bus'
import VueRouter from 'vue-router'
//打印
import Print from 'vue-print-nb'
// 签名
import vueEsign from 'vue-esign'
import "./common/js/rem.js";
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css' 
import eruda from 'eruda/eruda.js' // 引入工具包
eruda.init() // 初始化

Vue.use(ElementUI);
Vue.use(VueBus);
Vue.use(Print);
Vue.use(vueEsign);
Vue.use(Viewer) 

Viewer.setDefaults({
  Options: {
    // // 启用inline模式
    // 'inline': true,
    // // 显示右上角关闭按钮（jQuery版本无效）
    // 'button': true,
    // // 显示缩略图
    // 'navbar': true,
    // 显示当前图片的标题（现时alt属性及图片尺寸）
    // title: true,
    // // 显示工具栏
    // 'toolbar': true,
    // // 显示缩放百分比
    // 'tooltip': true,
    // // 图片是否可移动
    // 'movable': true,
    // // 图片是否可缩放
    // 'zoomable': true,
    // // 图片是否可旋转
    // 'rotatable': true,
    // // 图片是否可翻转
    // 'scalable': true,
    // // 使用css3过渡
    // 'transition': true,
    // // 播放时是否全屏
    // 'fullscreen': true,
    // // 是否支持键盘
    // 'keyboard': true,
    // // 设置大图片的url
    // 'url': 'data-source'
  }
})

Vue.config.productionTip = false

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
